module.exports = __webpack_public_path__ + "img/infoWorkflow.300bd9d1.png";